import React, { useState } from "react";
import axios from "axios";
import dayjs from 'dayjs';


const useRecord = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [responseData, setResponseData] = useState([])
    const getRecord = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/shift_management/api/record', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data?.map((column, column_index) => {
                    return {
                        ...column,
                        "record_class_data": column?.record_class_data?.map((item, item_index) => {
                            return{
                                ...item,
                                "class_working_end_time": dayjs(item?.class_working_end_time),
                                "class_working_start_time": dayjs(item?.class_working_start_time)
                            }
                        })
                    }
                }))
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postRecord = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/shift_management/api/record',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchRecord = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/shift_management/api/record',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteRecord = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/shift_management/api/record',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const exportRecord = (params) => {
        onBefore({
            axiosMode: "export"
        })
        axios
            .get('/shift_management/api/record_export/excel', {
                responseType: 'blob',
                params: params,
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '排班清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }
    const importRecord = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        form_data.append('default_column', JSON.stringify(data?.columns));
        axios
            .post(`/shift_management/api/record_import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    const downloadRecord = () => {
        onBefore({
            axiosMode: "download_sample"
        })
        axios
            .get('/shift_management/api/record_import/manual', {
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '排班匯入範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overRecord = (record) => {
        onBefore({
            axiosMode: "over"
        })
        axios
            .post('/question/api/task_import/over_data', record)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }   
    return {
        Record: data,
        RecordResponseData: responseData,
        getRecord,
        postRecord,
        patchRecord,
        deleteRecord,
        exportRecord,
        importRecord,
        downloadRecord,
        overRecord,
    }
}
export { useRecord }
